import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { PreferencesService } from '@services/preferences.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { map, startWith } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  private readonly translateService = inject(TranslateService);
  private readonly preferencesService = inject(PreferencesService);

  private readonly currentLang = toSignal(
    this.translateService.onLangChange.pipe(
      map((e: LangChangeEvent) => e.lang),
      startWith(
        this.translateService.getCurrentLang() ||
          this.preferencesService.getPreferencesSnapshot().language ||
          'fr',
      ),
    ),
  );

  readonly locale = computed(() => (this.currentLang() === 'en' ? 'en-US' : 'fr-FR'));

  format(date: Date, options: Intl.DateTimeFormatOptions): string {
    return new Intl.DateTimeFormat(this.locale(), options).format(date);
  }
}
